import Header from "./Header";
import Footer from "./Footer";
const VerifyDetails = () => {
  return <div>hello world</div>;
};
export default VerifyDetails;
